import gql from 'graphql-tag';

export default gql`
  mutation updateCompareModuleState($active: Bool!) {
    updateCompareModuleState(active: $active) @client
  }
`;
